/**PMC product solutions.*/
export enum Solutions {
    Online = 'a5f53ab3-d011-411c-9db5-a2bf42ab390d',
}